import { LandingParameters, Webinar } from '@anm/api/modules/hosting';
import isEqual from 'lodash/fp/isEqual';

import { ApplicationState } from '../../types';

export const selectLanding = ({ landings }: ApplicationState) => landings.data?.currentLanding;

export const selectLandingParams = ({ landings }: ApplicationState) => landings.data?.currentLanding?.parameters;

export const selectSavedParams = ({ landings }: ApplicationState) => landings.data?.savedLanding?.parameters;

export const selectLandingPublicStatus = ({ landings }: ApplicationState) => landings.data?.currentLanding?.public;

export const selectSaveLandingPendingStatus = ({ landings }: ApplicationState) => landings.saveLanding.isPending;

export const selectGetLandingPendingStatus = ({ landings }: ApplicationState) => landings.getLanding.isPending;

export const selectGetLandingError = ({ landings }: ApplicationState) => landings.getLanding.error;

export const selectSaveLanding = ({ landings }: ApplicationState) => landings.saveLanding;

export const selectWasLandingChanged = ({ landings }: ApplicationState) => {
  const { currentLanding, savedLanding } = landings.data || {};

  const excludeProps = (obj: LandingParameters = {}) => {
    delete obj?.emailCampaign?.link;

    return obj;
  };

  const prevParams = excludeProps(currentLanding?.parameters);
  const savedParams = excludeProps(savedLanding?.parameters);

  return !isEqual(prevParams, savedParams) || !isEqual(currentLanding?.template, savedLanding?.template);
};

export const selectLandingTheme = ({ landings }: ApplicationState) => landings.data?.currentLanding?.parameters?.theme;

export const selectLandingLayout = ({ landings }: ApplicationState) => landings.data?.currentLanding?.template;

export const selectLandingViewType = ({ landings }: ApplicationState) => landings.viewType;

export const selectIsWebinar = ({ landings }: ApplicationState) =>
  !!(landings.data?.currentLanding as Webinar)?.parameters?.streamId;

export const selectIsWebinarEmbedded = ({ landings }: ApplicationState) =>
  !!(landings.data?.currentLanding as Webinar)?.parameters?.isEmbedded;

export const selectWebinarStreamId = ({ landings }: ApplicationState) =>
  (landings.data?.currentLanding as Webinar)?.parameters?.streamId;
